import { createAction } from 'redux-actions';
import {TIMER_TICK} from "../actionTypes/timerActions.js"

export const timerTick=createAction(TIMER_TICK)
